import React from 'react'
import { Grid, Box, Link } from '@mui/material'
import { styled } from '@mui/system'
import { useTrimmedDownList } from 'packages/core'
import ItemDetails from '../ItemDetails'
import config from 'config'

const OverflowContainer = styled(Grid)(({ expanded }) => ({
    maxHeight: '20rem',
    overflowY: 'auto',
    transition: 'padding 0.5s ease',
    ...(expanded && {
        backgroundColor: '#f5f5f6',
        borderRadius: '0.8rem',
        boxShadow: '0 0.6rem 1.6rem 0 rgba(0, 0, 0, 0.05)',
        border: '0.1rem solid #d8d8dd',
        paddingTop: '0.8rem',
        paddingBottom: '0.8rem',
        marginBottom: '0.8rem',
    }),
}))

const PeopleList = ({ list, expandedStyles = true }) => {
    if (!list || list.length === 0) {
        list = []
    }

    const minCount = 2
    const { data, showAll, showLess, remainingItemsCount } = useTrimmedDownList(
        list?.map((p) => (
            <Grid item key={p.id}>
                <ItemDetails.Person
                    name={p.friendlyName}
                    imgSrc={`${config.BASE_EID_URL}${p.imageThumbUrl}`}
                />
            </Grid>
        )),
        minCount,
        <Grid item>
            <Box sx={{ fontSize: '1.4rem', color: '#5d6870' }}>-</Box>
        </Grid>,
    )

    return (
        <OverflowContainer
            container
            spacing={3}
            expanded={Boolean(data && data.length > 2 && expandedStyles)}
        >
            {data}
            {remainingItemsCount !== 0 && (
                <Box
                    sx={{
                        height: '100%',
                        display: 'flex',
                        width: '100%',
                        padding: '1.2rem',
                    }}
                >
                    <Link
                        component="button"
                        underline="always"
                        onClick={showAll}
                    >
                        +{remainingItemsCount} more
                    </Link>
                </Box>
            )}
            {remainingItemsCount === 0 && list.length > minCount && (
                <Box
                    sx={{
                        height: '100%',
                        display: 'flex',
                        width: '100%',
                        padding: '1.2rem',
                    }}
                >
                    <Link
                        component="button"
                        underline="always"
                        onClick={showLess}
                    >
                        Less
                    </Link>
                </Box>
            )}
        </OverflowContainer>
    )
}

export default PeopleList
